import React, { useEffect } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import BackToTop from "components/common/BackToTop";
import Drawer from "components/common/Drawer";
import { useScreenSize } from "provider/ScreenSizeProvider";
import { useAuth } from "provider/AuthContext";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";
// import MobileNoVerificationModalGen from "components/common/mobilenoverification/MobileNoVerificationModalGen";
// import DailySightUpdate from "components/common/DailySightUpdate";

function MainLayout() {
  // const location = useLocation();
  const { userProfile } = useAuth();
  const { isMobileView } = useScreenSize();
  const { toggleMobileVerify_gen, mobileVerifyDispatch } = useMobileVerifyContext();
  // const pathSegments = location.pathname.split('/');
  // const lastSegment = pathSegments[pathSegments.length - 1];
  
  // useEffect(() => {
  //   if (!userProfile?.is_mobile_verification_mandatory) {
  //     mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE_GEN", payload: true });
  //   }
  // }, [userProfile?.is_mobile_verification_mandatory])

  // const handleClose = () => {
  //   mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE_GEN", payload: false });
  // }

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      {isMobileView && <Drawer />}
      {/* {toggleMobileVerify_gen && <MobileNoVerificationModalGen handleSubmit={handleClose}  title="You need to verify your phone number"/>} */}
      <BackToTop />
      {/* <DailySightUpdate /> */}
      <ToastContainer
        position="top-center"
      />
    </>
  );
}

export default MainLayout;
